import { render, staticRenderFns } from "./tooltip-secondary.vue?vue&type=template&id=12776e95&scoped=true&"
import script from "./tooltip-secondary.vue?vue&type=script&lang=js&"
export * from "./tooltip-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12776e95",
  null
  
)

export default component.exports